import { useContext } from 'react';
import { AuthContext } from '../context/authContext';
var useAuth = function () {
    var value = useContext(AuthContext);
    return value;
};
export default useAuth;
